import validate from 'validate.js';
import { formCreateClasseSchema } from '../error/schemas/formCreateClasse';
import { getErrors } from '../error/getErrors';
import { isValid } from '../error/isValid';

export const classeFormErrorHandling = (classe, field, value) => {
  let errors = classe.errors;

  const message = validate({ [field]: value }, formCreateClasseSchema);
  errors = getErrors(
    errors,
    field,
    message && message[field] && message[field][0]
  );

  return {
    ...classe,
    values: {
      ...classe.values,
      [field]: value
    },
    errors,
    isValid: isValid(errors)
  };
};
